import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getReplenishmentReport = (params) => {
    return axios.get(`${backendHost}/api/admin/replenishment/report`, {params});
};

export {
    getReplenishmentReport
}